import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ControlContainer, FormControl, FormGroup } from '@angular/forms';
import { PessoaJuridica } from '@tivic-team/manager-ts/dist/grl';
import { ConcessaoTipo } from '@tivic-team/manager-ts/dist/mob/enums/concessao/concessao-tipo.enum';
import { PessoaJuridicaService } from 'app/services/grl/pessoa-juridica.service';
import { PessoaSearch } from 'app/services/grl/pessoa.search';
import { PessoaService } from 'app/services/grl/pessoa.service';
import { ConcessaoService } from 'app/services/mob/concessao.service';
import { ParentFormGroup } from 'app/tools/parent-formgroup';
import { EMPTY, Observable, from } from 'rxjs';
import { filter, map, mergeMap, tap } from 'rxjs/operators';

@Component({
  selector: 'autocomplete-vistoria-concessionario-mototaxi',
  templateUrl: './autocomplete-vistoria-concessionario-mototaxi.component.html',
  styleUrls: ['./autocomplete-vistoria-concessionario-mototaxi.component.scss'],
  viewProviders: [ParentFormGroup]
})
export class AutocompleteVistoriaConcessionarioMototaxiComponent implements OnInit {

  formGroup: FormGroup;
  concessionarios: PessoaJuridica[];
  @ViewChild("nmConcessionario", { static: false}) nmConcessionario: ElementRef;
  private _cdPessoa: number;

  constructor(
    private _controlContainer: ControlContainer,
    private _pessoaJuridicaService: PessoaJuridicaService,
    private _pessoaService: PessoaService,
    private _concessaoService: ConcessaoService
  ) { }

  ngOnInit() {
    this.formGroup = this._controlContainer.control as FormGroup;
    this.formGroup.addControl('concessionario', new FormControl());
    this.formGroup.get('concessionario').valueChanges.pipe(
      filter(keyword => this._validarTexto(keyword)),
      mergeMap(keyword => this._buscar(keyword)),
      tap(concessionarios => this._finalizarBusca(concessionarios))
    ).subscribe();
  }

  ngAfterViewInit() {
    this.formGroup.get('cdPessoa').valueChanges.pipe(
      mergeMap(cdConcessionario => this._carregar(cdConcessionario)),
      map(cdConcessionario => this.pessoaSelecionada(cdConcessionario)),
    ).subscribe();
  }

  pessoaSelecionada(pessoaJuridica: PessoaJuridica) {
    let cdConcessionario: number;
    
    if(!pessoaJuridica) return;
    this.nmConcessionario.nativeElement.value = pessoaJuridica.pessoa.nmPessoa;
    this._cdPessoa = pessoaJuridica.cdPessoa;
    this.formGroup.get('cdPessoa').setValue(pessoaJuridica.cdPessoa);
    this.formGroup.markAllAsTouched();
    cdConcessionario = this.formGroup.get('cdPessoa').value
    return this._concessaoService.getConcessionarioMototaxi(cdConcessionario).then(concessao => {
      this.formGroup.get('cdConcessao').setValue(concessao.cdConcessao);
    });
  }

  displayFn(concessionario: PessoaJuridica) {
    if (concessionario) {
      return concessionario.pessoa.nmPessoa;
    }
  }

  private _carregar(cdPessoa): Observable<PessoaJuridica>{
    if(!cdPessoa || isNaN(cdPessoa) || this._cdPessoa === cdPessoa){
      return EMPTY;
    }
    return from(this._pessoaService.get(cdPessoa));
  }
  private _validarTexto(keyword: string){
    return keyword && keyword.length > 2;
  }

  private _buscar(keyword: string) {
    return from(this._pessoaJuridicaService.getPermissionario(
      new PessoaSearch({nmPessoa: keyword, tpConcessao: ConcessaoTipo.MOTO_TAXI})
    ));
  }

  private _finalizarBusca(resultado: PessoaJuridica[]){
    this.concessionarios = resultado
  }
}
